import { Card, CardContent } from '@/components/ui/card'
import { parseH2Sections } from '@/lib/utils/parse-h2-sections'

interface PrdSectionsSummaryProps {
  body: string
}

/**
 * Strip leading "N. " numeric prefix for DISPLAY text only.
 * The slug (href) must remain based on the unstripped raw title so it
 * byte-matches the id attribute rehype-slug emits in the body.
 */
function stripNumericPrefix(title: string): string {
  return title.replace(/^\d+\.\s+/, '')
}

export function PrdSectionsSummary({ body }: PrdSectionsSummaryProps) {
  const sections = parseH2Sections(body)
  if (sections.length === 0) return null // hide card entirely — no empty stub (D-08)

  return (
    <Card>
      <CardContent className="p-4 space-y-2">
        <p className="text-sm font-medium mb-1">Sections</p>
        <ol className="list-decimal list-inside space-y-1 text-sm">
          {sections.map((section) => (
            <li key={section.slug}>
              <a
                href={`#${section.slug}`}
                className="text-foreground hover:text-muted-foreground hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-sm"
              >
                {stripNumericPrefix(section.title)}
              </a>
            </li>
          ))}
        </ol>
      </CardContent>
    </Card>
  )
}
